// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgramPage_container__QYhxI","gradient":"ProgramPage_gradient__1Tg0h"};